import { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";

import { Input } from "@/modules/common/components";
import { MagnifyingGlassIcon } from "@/modules/common/assets/icons";

import { FilterFieldRendererProps } from "../types";

const TextFilterField = ({ field, value, onChange }: FilterFieldRendererProps<string>) => {
  const [draft, setDraft] = useState(value ?? "");
  const [debounced] = useDebounce(draft, field.debounceMs ?? 400);

  useEffect(() => {
    setDraft(value ?? "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    if (debounced !== (value ?? "")) onChange(debounced || undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounced]);

  return (
    <Input
      placeholder={field.label}
      icon={<MagnifyingGlassIcon />}
      value={draft}
      onChange={(e) => setDraft(e.target.value)}
      className="h-10"
    />
  );
};

export default TextFilterField;
